import React, { useState } from "react";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import CloseIcon from "@mui/icons-material/CloseRounded";
function ErrorPopup({ errors }) {
  const [open, setOpen] = useState(true);
  const closeModal = () => setOpen(false);
  return (
    <Popup open={open} closeOnDocumentClick onClose={closeModal}>
      <div style={{ padding: "2rem 0", textAlign: "center" }} className="modal">
        <button onClick={closeModal}>
          <CloseIcon />
        </button>
        {errors &&
          errors.map((err) => {
            return <p>{err}</p>;
          })}
      </div>
    </Popup>
  );
}

export default ErrorPopup;
